import React from 'react'
import ContactForm from '../components/ContactForm/'
import Helmet from 'react-helmet'

const ContactEs = props => {
  const { langKey: lang } = props.pathContext
  const { edges: items } = props.data.allContactFormJson
  return (
    <div className="page contact">

    <Helmet
          title={`Contactanos | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos. ',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href:
                './en/contact',
            },
          ]}
        />

      <h1>Contáctenos</h1>
      <div className="grid-wrapper">
        <div className="block-first">
          <ContactForm lang={lang} items={items} />
        </div>
        <div className="block-second">
          <h3>Servicio las 24 horas, los 365 días del año</h3>
          <a className="mail" href="mailto:reserve@budget.com.ni">
           mailto:reserve@budget.com.ni 
          </a>
          <a href="tel:+50522559000"> +505 2255-9000</a>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query ContactEs {
    allContactFormJson {
      edges {
        node {
          fieldname
          required
          type
          label {
            en
            es
          }
        }
      }
    }
  }
`

export default ContactEs



// WEBPACK FOOTER //
// ./src/pages/contact.es.js